<template>
  <div class="phone">
    <div class="section" v-for="(item, index) in formList" :key="index">
      <component
        :is="componentNames[item.moduleValue]"
        :itemData="item"
        :title="title"
        :activityUrl="activityUrl"
      ></component>
    </div>
  </div>
</template>

<script>
import backgroundImg from "./components/BackgroundImg";
import banner from "./components/Banner";
import submitForm from "./components/SubmitForm";
import oldSubmitForm from "./components/OldSubmitForm";
import Player from "./components/Player";
import Service from "./components/Service";
import { getLandingPageDetail } from "@/api/common";

export default {
  components: {
    backgroundImg,
    banner,
    submitForm,
    oldSubmitForm,
    Player,
    Service,
  },
  data() {
    return {
      componentNames: {
        img: "backgroundImg",
        banner: "banner",
        form: "submitForm",
        player: "player",
        service: "service",
      },
      formList: [],
      title: "",
      activityUrl: "",
    };
  },
  created() {
    const isOld = this.$route.query.isOld || false;
    if (isOld) {
      this.componentNames.form = "oldSubmitForm";
    }
    this.getFormList();
  },
  mounted() {},
  methods: {
    getFormList() {
      getLandingPageDetail(this.$route.params.id).then((res) => {
        this.formList = JSON.parse(res.data?.remark || "[]");
        this.title = res.data.title;
        document.title = res.data.title;
        this.activityUrl = res.data.briefIntroduction;
      });
    },
  },
};
</script>

<style></style>
